import { useDispatch, useSelector } from "react-redux";
import { siteNewsSelector, getSiteNews } from "../siteNewsSlice";
import React from 'react'
import useIsSmallScreen from "../../../hooks/useIsSmallScreen";


export const useSiteNews = ({small, large}) => {

    const isSmallScreen = useIsSmallScreen();

    const dispatch = useDispatch();

    const [pageSize, setPageSize] = React.useState(large);

    const [pageAmount, setPageAmount] = React.useState(1);

    const [currentPage, setCurrentPage] = React.useState(1);

    const countNews = useSelector(x => x.site.siteNews.count);

    React.useEffect( () => {
        setCurrentPage(1);
        setPageSize(isSmallScreen ? small : large);

    }, [isSmallScreen, small, large])

    React.useEffect( () => {
        dispatch(getSiteNews({page: currentPage, page_size: pageSize}));
        setPageAmount(Math.ceil(countNews / pageSize));
        
    }, [dispatch, currentPage, pageSize, countNews])

    const siteNews = useSelector(siteNewsSelector.selectAll);
    const siteNewsAreLoading = useSelector(x => x.site.siteNews.isLoading);

    return [siteNews, siteNewsAreLoading, currentPage, setCurrentPage, pageAmount]
}
